module.exports = __webpack_public_path__ + "img/fad132e.png";